import React, { useState } from 'react';
import CheckboxList from '../../../Elements/InputComponents/BaseInputs/CheckboxList';

const monthOptions = [
  { value: '2026-07-01', label: 'Make the July 2026 draft again' },
  { value: '2026-08-01', label: 'Make the August 2026 draft again' },
  { value: '2026-09-01', label: 'Make the September 2026 draft again' },
];

function CheckboxListDemoComponent() {
  const [selectedValues, setSelectedValues] = useState(['2026-08-01']);

  return (
    <div>
      <CheckboxList
        options={monthOptions}
        selectedValues={selectedValues}
        onChange={setSelectedValues}
      />
      <p style={{ fontSize: 13, color: 'var(--ink-2)' }}>
        Ticked: {selectedValues.length > 0 ? selectedValues.join(', ') : 'none'}
      </p>
    </div>
  );
}

export const checkboxListDemo = {
  id: 'checkbox-list',
  title: 'Checkbox list',
  category: 'Inputs',
  importPath: 'Elements/InputComponents/BaseInputs/CheckboxList',
  notes: [
    'A list of labelled checkboxes, one for each { value, label } option. Clicking the label ticks the box too.',
    'selectedValues holds the values of the ticked options; onChange gets the new list on every tick or untick.',
    'Not an InputTypesEnum type: use it directly where a component needs several ticks, such as the Run now window of automatic invoicing.',
  ],
  snippet:
    '<CheckboxList\n  options={[{ value: 1, label: "First" }, { value: 2, label: "Second" }]}\n  selectedValues={selectedValues}\n  onChange={setSelectedValues}\n/>',
  render: CheckboxListDemoComponent,
};
